import React from 'react';
import { Navigation, Footer } from '../components/Navigation';
import usePageTitle from '../hooks/usePageTitle';

const SocialPage = () => {
  usePageTitle('Connect | Solypsizm');
  // Social platform data
  const socialPlatforms = [
    {
      id: 6,
      name: "Instagram",
      icon: "instagram",
      username: "@solypsizm",
      link: "https://www.instagram.com/solypsizm"
    },
    {
      id: 3,
      name: "YouTube",
      icon: "youtube",
      username: "Solypsizm",
      link: "https://www.youtube.com/@Solypsizm"
    },
    {
      id: 7,
      name: "TikTok",
      icon: "tiktok",
      username: "@solypsizm",
      link: "https://www.tiktok.com/@solypsizm"
    },
    {
      id: 1,
      name: "Twitter",
      icon: "twitter",
      username: "@solypsizm",
      link: "https://x.com/solypsizm"
    },
    {
      id: 2,
      name: "Bluesky",
      icon: "bluesky",
      username: "@solypsizm.bsky.social",
      link: "https://bsky.app/profile/solypsizm.bsky.social"
    },
    {
      id: 4,
      name: "Bandcamp",
      icon: "bandcamp",
      username: "solypsizm",
      link: "https://solypsizm.bandcamp.com/"
    },
    {
      id: 5,
      name: "Patreon",
      icon: "patreon",
      username: "Solypsizm",
      link: "https://patreon.com/Solypsizm"
    }
  ];

  return (
    <div className="min-h-screen bg-charcoal text-white">
      <Navigation currentPage="social" />

      {/* Hero Section */}
      <section className="electric-blizzard-bg pt-16 pb-8 md:pt-20 md:pb-10 relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-4 text-center z-10 relative">
          <h1 className="font-cinzel text-4xl sm:text-5xl md:text-6xl mb-6">Connect</h1>
          <p className="text-lg sm:text-xl">Follow Solypsizm</p>
        </div>
      </section>

      {/* Social Platforms */}
      <section className="pt-4 pb-12 md:pt-6 md:pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-6 md:space-y-8">
            {socialPlatforms.map((platform) => (
              <div key={platform.id} className="bg-charcoal-dark p-4 md:p-6 rounded-lg flex flex-col md:flex-row items-center gap-4 md:gap-8 hover:bg-opacity-80 transition-all border border-gray-800">
                <a
                  href={platform.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-charcoal flex items-center justify-center flex-shrink-0 border-2 border-transparent hover:border-neon-blue transition-all duration-300 shadow-lg"
                >
                  <img
                    src={require(`../assets/icons/${platform.icon}.svg`)}
                    alt={platform.name}
                    className="w-8 h-8 md:w-10 md:h-10"
                  />
                </a>
                <div className="flex-grow flex flex-col md:flex-row items-center md:justify-between w-full gap-4">
                  <div className="text-center md:text-left">
                    <h3 className="font-cinzel text-xl md:text-2xl mb-1">{platform.name}</h3>
                    <a
                      href={platform.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-neon-blue font-body text-sm md:text-base hover:underline block md:inline-block"
                    >
                      {platform.username}
                    </a>
                  </div>
                  <a
                    href={platform.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-8 py-2 border border-neon-blue text-neon-blue hover:bg-neon-blue hover:text-white transition-all rounded text-sm md:text-base font-bold tracking-wider min-w-[120px] text-center"
                  >
                    Follow
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 md:py-24 px-4 bg-charcoal-dark border-t border-gray-800">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-cinzel font-bold text-3xl md:text-4xl mb-6">Get In Touch</h2>
          <a
            href="mailto:music@solypsizm.com"
            className="text-gray-400 mb-8 max-w-lg mx-auto block hover:text-white transition-colors"
          >
            music@solypsizm.com
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SocialPage;
